import { useCustomThemeContext } from "../components/mui-providers";
import { getMaterialUITheme } from "../components/mui-providers/mui-theme-provider";

export const TIIVII_API_BASE_URL = process.env.REACT_APP_TIIVII_API_BASE_URL;
export const ADMIN_API_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL;

export const TIIVII_API_OPERATIONS = TIIVII_API_BASE_URL + "streamsources/:streamsource_id/operations";
export const TIIVII_API_DOWNLOAD_STREAMSOURCE_LOGS = TIIVII_API_BASE_URL + "streamsources/:streamsource_id/logfiles";
export const TIIVII_API_DOWNLOAD_STREAMSOURCE_SPECIFIC_LOG =
  TIIVII_API_BASE_URL + "streamsources/:streamsource_id/logfiles/:logfile_id";
export const TIIVII_API_DELETE_SECOND_COACH = TIIVII_API_BASE_URL + "streamsources/:streamsource_id/second_coach_url";
export const TIIVII_API_GET_LOCAL_RECORDINGS = TIIVII_API_BASE_URL + "events/:event_id/local-recordings";
export const TIIVII_API_GET_RECORDING_CLIPS = TIIVII_API_BASE_URL + "recording_clips";
export const TIIVII_API_UPDATE_CONTRACT_TEMPLATE =
  TIIVII_API_BASE_URL + "service-contracts/:contract_id/room-templates/:room_id/file";
export const TIIVII_API_GET_IN_USE_GRAPHICSET =
  TIIVII_API_BASE_URL + "customers/:customer_id/graphics-sets/:graphicset_id/is_in_use";
export const TIIVII_API_POST_OCURRENCE_SOURCE =
  TIIVII_API_BASE_URL + "service-contracts/:contract_id/event-types/:event_type_id/occurrence_sources";
export const TIIVII_API_DELETE_OCURRENCE_SOURCE =
  TIIVII_API_BASE_URL +
  "service-contracts/:contract_id/event-types/:event_type_id/occurrence_sources/:occurrence_source_name";
export const TIIVII_API_GET_CONTRACTS = TIIVII_API_BASE_URL + "service-contracts";
export const TIIVII_API_GET_USER_CUSTOMERS = TIIVII_API_BASE_URL + "users/:username/customers";
export const TIIVII_API_GET_USER_CONTRACTS = TIIVII_API_BASE_URL + "users/:username/service-contracts";
export const TIIVII_API_GET_CONTRACT_RECORD_AND_SHARE_AVAILABLE =
  TIIVII_API_BASE_URL + "service-contracts/:contract_id/recordAndShareAvailable";
export const TIIVII_API_GET_SUBDEPLOYMENTS = TIIVII_API_BASE_URL + "service-contracts/:contract_id/subdeployments";
export const TIIVII_API_DELETE_PARTNER_FOR_CUSTOMER =
  TIIVII_API_BASE_URL + "customers/:customer_id/partners/:partner_id";
export const TIIVII_API_NEW_SHIELD_EVENT = TIIVII_API_BASE_URL + "customers/:customer_id/assets";
export const TIIVII_API_POST_GLOBAL_ASSET = TIIVII_API_BASE_URL + "assets";
export const TIIVII_GET_CONTRACT_INFO_OTT =
  TIIVII_API_BASE_URL + "service-contracts/:contract_id/has_tiivii_ott_configured";
export const TIIVII_GET_RECORDING_DOWNLOAD_URL = TIIVII_API_BASE_URL + "recordings/:recording_id/download_url";

export const TIIVII_API_GET_ROOM_TEMPLATES = TIIVII_API_BASE_URL + "service-contracts/:contract_id/room-templates";
export const TIIVII_API_GET_ROOM_TEMPLATE =
  TIIVII_API_BASE_URL + "service-contracts/:contract_id/room-templates/:room_id";
export const TIIVII_API_GET_EVENT_TYPE = TIIVII_API_BASE_URL + "event-types/:event_type_id";
export const TIIVII_API_GET_CONTRACT = TIIVII_API_BASE_URL + "service-contracts/:contract_id";
export const TIIVII_API_GET_SCOREBOARD_TYPES =
  TIIVII_API_BASE_URL + "service-contracts/:contract_id/event-types/:event_type_id/scoreboards_available";
export const TIIVII_API_GET_SCOREBOARD_TEMPLATES =
  TIIVII_API_BASE_URL + "service-contracts/:contract_id/event-types/:event_type_id/templates";
export const TIIVII_API_EVENTS = TIIVII_API_BASE_URL + "events";
export const TIIVII_API_ASSET_CATEGORIES = TIIVII_API_BASE_URL + "asset-categories";
export const TIIVII_API_ASSETS_BY_CUSTOMER = TIIVII_API_BASE_URL + "customers/:customer_id/assets";
export const TIIVII_API_GET_OCCURRENCE_SOURCES =
  TIIVII_API_BASE_URL + "service-contracts/:contract_id/event-types/:event_type_id/occurrence_sources";
export const TIIVII_API_GET_EVENT = TIIVII_API_BASE_URL + "events/:event_id";
export const TIIVII_API_PATCH_EVENT = TIIVII_API_BASE_URL + "events/:event_id";
export const TIIVII_API_DELETE_EVENT = TIIVII_API_BASE_URL + "events/:event_id";
export const TIIVII_API_DELETE_EVENT_GRAPHIC_SET = TIIVII_API_BASE_URL + "events/:event_id/graphic-set";
export const TIIVII_API_MANAGE_COMPONENT = TIIVII_API_BASE_URL + "events/:event_id/manage-component";

export const TIIVII_CHECK_USER_PASS_ENDPOINT = `${TIIVII_API_BASE_URL}users/check-user-pass`;
export const TIIVII_UPDATE_USER_ENDPOINT = `${TIIVII_API_BASE_URL}users/:username`;

export const TIIVII_CREATE_ROOM_TEMPLATE_ENDPOINT = `${TIIVII_API_BASE_URL}service-contracts/:contract_id/room-templates`;
export const TIIVII_UPDATE_ROOM_TEMPLATE_ENDPOINT = `${TIIVII_API_BASE_URL}service-contracts/:contract_id/room-templates/:room_id`;

export const TIIVII_GET_EVENTS_ENDPOINT = `${TIIVII_API_BASE_URL}events`;
export const TIIVII_GET_DEPLOYMENTS_ENDPOINT = `${TIIVII_API_BASE_URL}deployments`;
export const TIIVII_POST_DEPLOYMENT_ENDPOINT = `${TIIVII_API_BASE_URL}deployments`;
export const TIIVII_GET_DEPLOYMENT_ENDPOINT = `${TIIVII_API_BASE_URL}deployments/:deployment_id`;
export const TIIVII_PATCH_DEPLOYMENT_ENDPOINT = `${TIIVII_API_BASE_URL}deployments/:deployment_id`;
export const TIIVII_GET_DEPLOYMENT_STREAM_SOURCES_ENDPOINT = `${TIIVII_API_BASE_URL}deployments/:deploymentId/streamsources`;
export const TIIVII_GET_RECORDINGS_ENDPOINT = `${TIIVII_API_BASE_URL}recordings`;
export const TIIVII_GET_STREAMSOURCES_ENDPOINT = `${TIIVII_API_BASE_URL}streamsources`;
export const TIIVII_GET_DEPLOYMENT_STREAMSOURCES_ENDPOINT = `${TIIVII_API_BASE_URL}deployments/:deployment_id/streamsources`;

export const ADMIN_API_CHECK_EVU = `${ADMIN_API_BASE_URL}tiivii-evu-tester/check`;

export const MATERIAL_UI_THEME = () => {
  const { customTheme } = useCustomThemeContext();
  return getMaterialUITheme(customTheme);
};
export const DOWNLOAD_STATUS_UNKNOWN = "UNKNOWN";
export const DOWNLOAD_STATUS_ERROR = "ERROR";
export const DOWNLOAD_STATUS_INPROGRESS = "INPROGRESS";
export const DOWNLOAD_STATUS_AVAILABLE = "AVAILABLE";

export const STATUS_PENDING = "pending";

export const SOURCE_ICON_TYPE_CLOSE = "close";
export const SOURCE_ICON_TYPE_CHECK = "check";
export const SOURCE_FUNCTION_TYPE_ACTIVATE = "activate";
export const SOURCE_FUNCTION_TYPE_DEACTIVATE = "deactivate";
export const SOURCE_FUNCTION_STATE_ACTIVATED = "activated";
export const SOURCE_FUNCTION_STATE_DEACTIVATED = "deactivated";
export const SOURCE_FUNCTION_STATE_ENABLED = "enabled";
export const SOURCE_FUNCTION_STATE_DISABLED = "disabled";
export const SOURCE_USE_SCOREBOARD = "scoreboard";
export const SOURCE_USE_FIXED = "fixed";
export const SOURCE_USE_FIXED_LEFT = "fixed-left";
export const SOURCE_USE_FIXED_RIGHT = "fixed-right";
export const SOURCE_TYPE_CAMERA = "camera";

export const GENERAL_STATUS_KO = "ko";

export const RECORDING_EXPIRATION_WARNING_DAYS = 7;
export const RECORDING_EXPIRATION_WARNING_DAYS_MAX = 0;

export const STREAMSOURCE_SERVICE_ACTION_GET_LOGS = "get-logs";
export const STREAMSOURCE_SERVICE_ACTION_CHECK_SERVER_REPORT = "check-server-report";
export const STREAMSOURCE_SERVICE_ACTION_CHECK_CURRENT_CODIFICATIONS = "check-current-codifications";
export const STREAMSOURCE_SERVICE_ACTION_CHECK_CURRENT_CONNECTIONS = "check-current-connections";
export const STREAMSOURCE_SERVICE_ACTION_CHECK_RECORDINGS_IN_PROGRESS = "check-recordings-in-progress";
export const STREAMSOURCE_SERVICE_ACTIONS = [
  STREAMSOURCE_SERVICE_ACTION_GET_LOGS,
  STREAMSOURCE_SERVICE_ACTION_CHECK_SERVER_REPORT,
  STREAMSOURCE_SERVICE_ACTION_CHECK_CURRENT_CODIFICATIONS,
  STREAMSOURCE_SERVICE_ACTION_CHECK_CURRENT_CONNECTIONS,
  STREAMSOURCE_SERVICE_ACTION_CHECK_RECORDINGS_IN_PROGRESS,
];

export const ROLE_SUPER_USER = "TIIVII_SUPER_USER";
export const ROLE_PARTNER_USER = "TIIVII_PARTNER_USER";
export const ROLE_ADMIN_USER = "TIIVII_ADMIN_USER";
export const ROLE_CLIENT_USER = "TIIVII_CLIENT_USER";

export const HTTP_CODE_OK = 200;
export const HTTP_CODE_CREATED = 201;
export const HTTP_CODE_UPDATED = 204;
export const HTTP_ERROR_CODE_400 = 400;
export const HTTP_ERROR_CODE_401 = 401;
export const HTTP_ERROR_CODE_403 = 403;
export const HTTP_ERROR_CODE_404 = 404;
export const HTTP_ERROR_CODE_409 = 409;
export const HTTP_ERROR_CODE_500 = 500;

export const HTTP_MESSAGE_400 = "Invalid request";
export const HTTP_MESSAGE_401 = "Unauthorized";
export const HTTP_MESSAGE_403 = "Forbidden";
export const HTTP_MESSAGE_404 = "Not found";
export const HTTP_MESSAGE_409 = "Conflict";
export const HTTP_MESSAGE_500 = "Server error";
